import { useEffect, useState } from 'react';

import { Cms } from '@bytel/product-wall';
import { Button, ButtonList, ButtonVariant, Justify, Modal, ModalBody, ModalFooter, View } from '@bytel/trilogy-react';

import { cmsService } from '@services/cms';

import { FaiType } from '@app-types/plan';

import { Loader } from '@components/loader';

interface FaiOfferDetailsModalProps {
    plan: FaiType;
    isOpen: boolean;
    onClose: () => void;
}

export function FaiOfferDetailsModal({ plan, isOpen = false, onClose }: Readonly<FaiOfferDetailsModalProps>) {
    const [content, setContent] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        cmsService
            .getPartialsCms(`fai/${plan.rangeNg}-${plan.commercialSeries}`)
            .then((response) => setContent(response ?? ''))
            .finally(() => setIsLoading(false));
    }, [plan.rangeNg]);

    return (
        <Modal active={isOpen} onClose={onClose} title={plan.name}>
            <ModalBody>
                {isLoading ? (
                    <View flexable justify={Justify.CENTER}>
                        <Loader />
                    </View>
                ) : (
                    <Cms content={content} />
                )}
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.PRIMARY} onClick={onClose}>
                        Fermer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
